import { AutogenModelCustomerLookup, AutogenRowCustomerLookup } from "./autogen/AutogenModelCustomerLookup";

export class ModelCustomerLookup extends AutogenModelCustomerLookup<RowCustomerLookup> {
    constructor() {
        super(RowCustomerLookup);
    }
}

export class RowCustomerLookup extends AutogenRowCustomerLookup {
}